import React, { forwardRef } from "react";
import classNames from "classnames";

import { assignRef } from "./assignRef";
import { useBottomSheetContext } from "./bottomSheetContext";
import { useStartingStyle } from "./useStartingStyle";

const BASE_BACKDROP_Z = 10000;

export type BackdropProps = React.HTMLAttributes<HTMLDivElement>;

export const Backdrop = forwardRef<HTMLDivElement, BackdropProps>(
  ({ className, onClick, style, ...rest }, forwardedRef) => {
    const { open, setOpen, dismissible, modal, backdropRef, dragging, isNested, nestedOpenCount, nestDepth } =
      useBottomSheetContext();
    const startingStyle = useStartingStyle(open, backdropRef);
    const hasNestedOpen = nestedOpenCount > 0;

    function setRefs(node: HTMLDivElement | null) {
      backdropRef.current = node;
      assignRef(forwardedRef, node);
    }

    return (
      <div
        {...rest}
        ref={setRefs}
        className={classNames("ui-bottom-sheet-dialog-backdrop", className)}
        style={{ zIndex: BASE_BACKDROP_Z + nestDepth * 2, ...style }}
        data-open={open ? "" : undefined}
        data-starting-style={startingStyle ? "" : undefined}
        data-dragging={dragging ? "" : undefined}
        data-modal={modal ? undefined : "false"}
        data-nested={isNested ? "" : undefined}
        onClick={event => {
          onClick?.(event);
          if (event.defaultPrevented) {
            return;
          }
          if (hasNestedOpen) {
            return;
          }
          if (modal && dismissible) {
            setOpen(false, "backdrop-press");
          }
        }}
      />
    );
  },
);

Backdrop.displayName = "BottomSheet.Backdrop";
